/**
 * Landing v2 — the ORIGINAL main.html brand mark, faithfully reproduced
 * (owner: "use the logo from the previous main.html as it's better").
 * Geometry lifted from main.html's .brand-mark CSS: 34px deep-green tile,
 * border-radius 11, inset white ring, two lime rounded blades rotated -35°
 * (7x19 at 9,8 and 7x14 at right:8,top:6 → x=19).
 *
 * `animated` plays a one-time entrance: the tile settles, then each blade
 * grows in with a spring — subtle, brand-true, motion-safe.
 */

export function BrandMarkV2({
  size = 34,
  animated = false,
  className,
}: {
  size?: number
  animated?: boolean
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 34 34"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="BiteBalance"
      focusable="false"
    >
      <rect x="0" y="0" width="34" height="34" rx="11" fill="#1d4b39" />
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="33"
        rx="10.5"
        fill="none"
        stroke="#ffffff"
        strokeOpacity="0.15"
      />
      <g transform="rotate(-35 17 17)">
        <rect
          x="9"
          y="8"
          width="7"
          height="19"
          rx="3.5"
          fill="#d8f184"
          className={animated ? "bbv2-blade bbv2-blade-1" : undefined}
        />
        <rect
          x="19"
          y="6"
          width="7"
          height="14"
          rx="3.5"
          fill="#d8f184"
          className={animated ? "bbv2-blade bbv2-blade-2" : undefined}
        />
      </g>
    </svg>
  )
}
